// Coalesce repeated invalidations and prevent an older filter/session response
// from overwriting a newer view. No response data is cached across callers.
export function latestRequest() {
  let active = null;
  let generation = 0;
  return {
    run(key, request, { success, failure, settled = () => {} }) {
      if (active?.key === key) return active.promise;
      active?.controller.abort();
      const controller = new AbortController();
      const current = ++generation;
      const promise = Promise.resolve().then(() => request(controller.signal))
        .then((value) => { if (current === generation) success(value); })
        .catch((error) => { if (current === generation && !controller.signal.aborted) failure(error); })
        .finally(() => {
          if (current === generation) { active = null; settled(); }
        });
      active = { key, controller, promise };
      return promise;
    },
    cancel() { generation += 1; active?.controller.abort(); active = null; },
  };
}
